module.exports = __webpack_public_path__ + "img/horizontal_4_6_6000.584bdcf1.png";